import React from 'react'
import { connect } from 'react-redux'

/**
 * Creates visual "hotzones" overlay using CSS.
 * This is to visualize the "hotzones" where buttons
 * can be hard to click on mobile devices, without that
 * activating some feature on the phone.
 */
@connect(state => ({ hotzones: state.base.hotzones }))
export default class Dev extends React.Component {
  state = {
    portrait: false,
  }

  /**
   * Checks the orientation to make sure that the correct
   * hotzones are enabled, and adds a resize event listener.
   */
  componentDidMount = () => {
    window.addEventListener('resize', this.setOrientation)
    this.setOrientation()
  }

  /**
   * Removes the resize event listener.
   */
  componentWillUnmount() {
    window.removeEventListener('resize', this.setOrientation)
  }

  /**
   * Checks the current orientation.
   */
  setOrientation = () => {
    const portrait = window.innerHeight > window.innerWidth
    if (this.state.portrait !== portrait) {
      this.setState({ portrait })
    }
  }

  render() {
    const { portrait = false } = this.state
    const { hotzones = {} } = this.props

    return (
      <div className="hotzones">
        { hotzones.ios && (
          <div className="ios">
            { !portrait && (<div className="zone top" />) }
            <div className="zone bottom" />
          </div>
        )}
        { (hotzones.samsung && portrait) && (
          <div className="samsung">
            <div className="zone right" />
          </div>
        )}
      </div>
    )
  }
}
